import { Redirect } from 'aurelia-router';
/**
 * A validation step class that, once added to the app router, will use the `appRouting`
 * service to check if a user can access a route or not.
 */
class AppRoutingStep {
  /**
   * @param {Route}      router     To generate a route in case the navigation needs to be redirected.
   * @param {AppRouting} appRouting To validate the routes settings.
   */
  constructor(router, appRouting) {
    'inject';

    /**
     * A local reference for the `router` service.
     * @type {Router}
     * @access protected
     */
    this._router = router;
    /**
     * A local reference for the `appRouting` service.
     * @type {AppRouting}
     * @access protected
     */
    this._appRouting = appRouting;
  }
  /**
   * Validates whether a user can access a route or not.
   * @param {NavigationInstruction} navigationInstruction The instruction will all the routes the
   *                                                      route is trying to navigate to.
   * @param {Function}              next                  The function to be called when the
   *                                                      validation ends.
   * @param {Function}              next.cancel           The function to be called in case the
   *                                                      navigation needs to be canceled with a
   *                                                      redirection.
   * @return {Promise<*,Error>}
   */
  run(navigationInstruction, next) {
    let failedValidation = null;
    navigationInstruction.getAllInstructions()
    .some((route) => {
      const validation = this._appRouting.validate(route.config.settings);
      if (validation.denied) {
        failedValidation = validation;
      }

      return validation.denied;
    });

    return failedValidation ?
      next.cancel(new Redirect(this._router.generate(failedValidation.redirectTo))) :
      next();
  }
}

export { AppRoutingStep };
